export default "__VITE_ASSET__BFcoYufv__"